import React from 'react'
import { ApolloError } from '@apollo/client'

type Props = {
  error: ApolloError
}

const ValidationAlert: React.FC<Props> = ({ error }) => {
  if (!error) return null

  const messages = error.graphQLErrors.map(
    ({ extensions: { code, exception } }) => {
      if (code === 'BAD_USER_INPUT')
        return exception.details.map(error => error.message).join('\n')
    }
  )

  return (
    <div
      style={{
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word',
        color: '#FF6D6D',
      }}
    >
      {messages.join('\n')}
    </div>
  )
}

export default ValidationAlert
